"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderMultiMenuLists = exports.getRelations = exports.defaultAllValue = exports.separator = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var tips_1 = require("../../tips");
var checktree_1 = require("../../checktree");
var CascaderBox_1 = require("../CascaderBox");
var list_1 = require("../../list");
var checkbox_1 = require("../../checkbox");
var CascaderLoading_1 = require("../CascaderLoading");
var i18n_1 = require("../../i18n");
var util_1 = require("../../util");
var noop_1 = require("../../_util/noop");
// CheckTree 需要数值形式多段值转为字符串值，使用该字符串拼接
exports.separator = "_#$SEP$_";
exports.defaultAllValue = "__CascaderAllValue__";
function getRelations(data, all) {
    var relations = {};
    var disabledNames = [];
    var traverse = function (data, parentValue) {
        (data.options || []).forEach(function (option) {
            var _a;
            var value = parentValue === null
                ? option.value
                : "" + parentValue + exports.separator + option.value;
            if (parentValue !== null) {
                relations[value] = parentValue;
            }
            else if (all) {
                relations[value] = ((_a = all) === null || _a === void 0 ? void 0 : _a.value) || exports.defaultAllValue;
            }
            if (option.disabled) {
                disabledNames.push(value);
            }
            if (option.child) {
                traverse(option.child, value);
            }
        });
    };
    traverse(data, null);
    return { relations: relations, disabledNames: disabledNames };
}
exports.getRelations = getRelations;
function CascaderMultiMenuLists(_a) {
    var _b;
    var data = _a.data, curValueList = _a.curValueList, onChange = _a.onChange, onLoad = _a.onLoad, onSelect = _a.onSelect, expandTrigger = _a.expandTrigger, scheduleUpdate = _a.scheduleUpdate, all = _a.all, tips = _a.tips, bottomTips = _a.bottomTips, _c = _a.onScrollBottom, onScrollBottom = _c === void 0 ? noop_1.noop : _c;
    var enterTimerRef = react_1.useRef(null);
    var t = i18n_1.useTranslation();
    var classPrefix = util_1.useConfig().classPrefix;
    var allValue = ((_b = all) === null || _b === void 0 ? void 0 : _b.value) || exports.defaultAllValue;
    // 内部状态
    var _d = tslib_1.__read(react_1.useState([]), 2), internalValue = _d[0], setInternalValue = _d[1];
    var _e = react_1.useMemo(function () { return getRelations(data, all); }, [
        data,
        all,
    ]), relations = _e.relations, disabledNames = _e.disabledNames;
    var lists = react_1.useMemo(function () {
        var lists = [data];
        internalValue.forEach(function (value) {
            var option = lists[lists.length - 1].options.find(function (option) { return option.value === value; });
            if (option && option.child) {
                lists.push(option.child);
            }
        });
        return lists;
    }, [data, internalValue]);
    react_1.useEffect(function () {
        if (scheduleUpdate) {
            scheduleUpdate();
        }
    }, [lists, scheduleUpdate]);
    function handleSelect(index, value, _a) {
        var event = _a.event, hasChild = _a.hasChild;
        var newValue = tslib_1.__spread(internalValue.slice(0, index), [value]);
        setInternalValue(newValue);
        if (!hasChild) {
            onSelect(newValue, { event: event, options: CascaderBox_1.getOptions(data, newValue) });
        }
    }
    return (react_1.default.createElement(checktree_1.CheckTree, { relations: relations, disabledNames: disabledNames, value: curValueList.map(function (list) { return list.join(exports.separator); }), onChange: function (names, _a) {
            var event = _a.event;
            var value = names.map(function (name) { return name.split(exports.separator); });
            onChange(value, {
                event: event,
                options: value.map(function (i) { return CascaderBox_1.getOptions(data, i); }),
            });
        } }, lists.map(function (_a, index) {
        var _b;
        var options = _a.options;
        return (react_1.default.createElement(list_1.List, { type: "option", className: classPrefix + "-list--checkoption", key: index, onScrollBottom: function () { return onScrollBottom(internalValue.slice(0, index)); } }, options ? (react_1.default.createElement(react_1.default.Fragment, null,
            tips && (react_1.default.createElement(list_1.List.StatusTip, null, tips(internalValue.slice(0, index)))),
            index === 0 && all && (react_1.default.createElement(list_1.List.Item, null,
                react_1.default.createElement(checkbox_1.Checkbox, { name: allValue }, ((_b = all) === null || _b === void 0 ? void 0 : _b.label) || t.selectAllText))),
            options.map(function (_a) {
                var value = _a.value, label = _a.label, child = _a.child, disabled = _a.disabled;
                var optionValue = tslib_1.__spread(internalValue.slice(0, index), [value]);
                var triggerProps = {};
                if (child) {
                    triggerProps =
                        expandTrigger === "hover" && child
                            ? {
                                onMouseEnter: function (event) {
                                    enterTimerRef.current = setTimeout(function () {
                                        handleSelect(index, value, {
                                            event: event,
                                            hasChild: true,
                                        });
                                    }, 150);
                                },
                                onMouseLeave: function () {
                                    clearTimeout(enterTimerRef.current);
                                },
                            }
                            : {
                                onClick: function (event) {
                                    handleSelect(index, value, {
                                        event: event,
                                        hasChild: Boolean(child),
                                    });
                                },
                            };
                }
                var itemProps = tslib_1.__assign(tslib_1.__assign({}, triggerProps), { key: tslib_1.__spread(internalValue.slice(0, index), [value]).join("/"), disabled: disabled, selected: false });
                if (child) {
                    return (react_1.default.createElement(list_1.List.SubMenu, tslib_1.__assign({}, itemProps, { label: react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(checkbox_1.Checkbox, { name: optionValue.join(exports.separator), style: { paddingRight: 0, display: "inline-block" } }),
                            react_1.default.createElement("div", { style: {
                                    display: "inline-block",
                                    marginRight: 28,
                                    lineHeight: "30px",
                                } }, label || value)) })));
                }
                return (react_1.default.createElement(list_1.List.Item, tslib_1.__assign({}, itemProps),
                    react_1.default.createElement(checkbox_1.Checkbox, tslib_1.__assign({ name: optionValue.join(exports.separator) }, triggerProps), label || value)));
            }),
            options.length === 0 && (react_1.default.createElement(list_1.List.StatusTip, null,
                react_1.default.createElement(tips_1.EmptyTip, null))),
            bottomTips && (react_1.default.createElement(list_1.List.StatusTip, null, bottomTips(internalValue.slice(0, index)))))) : (react_1.default.createElement(list_1.List.StatusTip, null,
            react_1.default.createElement(CascaderLoading_1.CascaderLoading, { onLoad: function () {
                    return onLoad(internalValue, CascaderBox_1.getOptions(data, internalValue));
                } })))));
    })));
}
exports.CascaderMultiMenuLists = CascaderMultiMenuLists;
CascaderMultiMenuLists.displayName = "CascaderMultiMenuLists";
//# sourceMappingURL=CascaderMultiMenuLists.js.map